import { render, staticRenderFns } from "./ViewDialForm.vue?vue&type=template&id=10e6e3d9&scoped=true&"
import script from "./ViewDialForm.vue?vue&type=script&lang=js&"
export * from "./ViewDialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6e3d9",
  null
  
)

export default component.exports